import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    $.extend(window.TResponsiveMultiOptions, {
        getUKBetsItemCssClass(options) {
            var isValid = options ? options.isMinBetNumberValid : BetSlip.CurrentMode.areAllSinglesValid();
            return isValid ? "" : "disabled";
        }
    });
});
//# sourceMappingURL=TResponsiveMultiOptions.js.map